import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import CustomPromotions from "./CustomPromotions.json";
import RiveComponent from "../Shared/RiveComponent";
import { SuperCasinoUtrkeWidget } from "../Casino/SuperCasinoUtrkeWidget.jsx";

export default function BonusItem(props) {
    const [state, setState] = useState({
        days: "00",
        hours: "00",
        minutes: "00",
        seconds: "00",
        promotionText: "Trajanje promocije",
        promotionFinished: false,
    });
    const [promotionText, setPromotionText] = useState("Trajanje promocije");

    const time = new Date().getHours();
    let interval = null;

    useEffect(() => {
        var startDateTime = new Date(props.promotion.startDate);
        var endDateTime = new Date(props.promotion.endDate);

        if (new Date() < startDateTime) {
            setPromotionText("Do promocije");
            startBannerCountDownTime(startDateTime);
        } else {
            startBannerCountDownTime(endDateTime);
        }

        return cleanUpCountDownTime;
    }, [props.info]);

    function cleanUpCountDownTime() {
        if (interval)
            clearTimeout(interval);

        interval = null;
    }

    function startBannerCountDownTime(endDateTime) {
        cleanUpCountDownTime();

        // Get todays date and time
        var now = new Date().getTime();
        // Find the distance between now an the count down date
        var distance = endDateTime - now;

        // Time calculations for days, hours, minutes and seconds
        var days = ("0" + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
        var hours = (
            "0" + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        ).slice(-2);
        var minutes = (
            "0" + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        ).slice(-2);
        var seconds = ("0" + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);

        setState({
            ...state,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
        });

        // If the count down is finished, write some text
        if (distance < 0) {
            setState({
                ...state,
                days: "00",
                hours: "00",
                minutes: "00",
                seconds: "00",
            });
            if (
                new Date() > new Date(props.promotion?.startDate) &&
                new Date() < new Date(props.promotion.endDate)
            ) {
                setPromotionText("Trajanje promocije");
                startBannerCountDownTime(new Date(props.promotion.endDate));
            } else {
                setState({ ...state, promotionFinished: true });
            }
        } else {
            interval = setTimeout(() => startBannerCountDownTime(endDateTime), 1000);
        }
    }

    function renderResults() {
        return (
            <>
                <div className="header-container">
                    <p className="winners-title">Dobitnici</p>
                </div>

                <table className="">
                    <thead>
                        <tr>
                            {props.promotion.vrstaKampanje == "SuperSkok" ||
                                props.promotion.vrstaKampanje == "SuperSkokUtrkaSIgrama" ||
                                props.promotion.vrstaKampanje == "CasinoMaratonTurnover" ||
                                props.promotion.vrstaKampanje == "SuperSkokUtrka" ? (
                                ""
                            ) : (
                                <th className="date-title">Dan i sat</th>
                            )}
                            <th
                                className={
                                    props.promotion.vrstaKampanje == "SuperBomba" ||
                                        props.promotion.vrstaKampanje == "SuperBombaSIgrama"
                                        ? "player-title"
                                        : "skok-title"
                                }
                            >
                                Igrač
                            </th>
                            <th className="reward-title">
                                {(props.promotion.vrstaKampanje == "SuperSkok" &&
                                    !props.promotion.uplaceno) ||
                                    (props.promotion.vrstaKampanje == "SuperSkokUtrkaSIgrama" &&
                                        !props.promotion.uplaceno)
                                    ? "Osvojeno bodova"
                                    : "Osvojeno"}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.promotion &&
                            props.promotion.winners &&
                            props.promotion.winners
                                .slice(0, 6)
                                .map((player, i) => renderPlayerRow(player, i))}
                    </tbody>
                </table>
            </>
        );
    }

    function renderPlayerRow(player, i) {
        return (
            <tr className="winner" key={i}>
                {props.promotion.vrstaKampanje == "SuperBomba" ||
                    props.promotion.vrstaKampanje == "SuperBombaSIgrama" ? (
                    <td className="">
                        {casino.utils.dateToShortDateString(new Date(player.winningTime))}.
                    </td>
                ) : null}
                <td
                    className={
                        props.promotion.vrstaKampanje == "SuperBomba" ||
                            props.promotion.vrstaKampanje == "SuperBombaSIgrama"
                            ? "player"
                            : "skok-player"
                    }
                >
                    {player.name}
                </td>
                {(props.promotion.vrstaKampanje == "SuperSkokUtrkaSIgrama" &&
                    !props.promotion.uplaceno) ||
                    (props.promotion.vrstaKampanje == "SuperSkokUtrka" &&
                        !props.promotion.uplaceno) ? (
                    <td className="skok-bodovi">{player.points}</td>
                ) : (
                    <td className="reward">
                        {casino.utils.numberWithCurrencyFromated(
                            player.prize,
                            player.valuta
                        )}
                    </td>
                )}
            </tr>
        );
    }

    function renderChallenge(challenge, index) {
        return (
            <div key={"challenge-" + index} className="challenge">
                <div className="challenge-icon">
                    <span
                        className="icon"
                        style={{
                            backgroundImage: "url(" + challenge.settings.icon_url + ")",
                        }}
                    ></span>
                    <span className="coin-container">
                        <span className="coin">
                            <span className="coin-ammount">{challenge.points}</span>
                        </span>
                    </span>
                </div>
                <div className="challenge-title">{challenge.title}</div>
                <div className="challenge-slider">
                    <div className="slider-title">
                        {challenge && challenge.steps > 0
                            ? "IZVRŠENO " + challenge.completed_steps + "/" + challenge.steps
                            : "IZVRŠENO " + challenge.progress * 100 + "%"}
                    </div>
                    <div className="slider-bar">
                        <div
                            className="slider-progress"
                            style={{ width: challenge.progress * 100 + "%" }}
                        ></div>
                    </div>
                </div>
                <div className="challenge-info">{challenge.description}</div>
                <button
                    className="challenge-btn"
                    onClick={() => (window.location = challenge.settings.mobile_url)}
                >
                    IGRAJ
                </button>
            </div>
        );
    }

    const PROMOTIONS_BY_CODE = Object.fromEntries(CustomPromotions.map(p => [p.code, p]));
    const promoConfig = PROMOTIONS_BY_CODE[props.promotion.code] || {};
    const imaIgraca = (props.user?.igracID !== null && props.user?.igracID !== undefined);
    return (
        <>
            {(props.promotion.size == 2 || props.promotion.size == 3) &&
                (PROMOTIONS_BY_CODE[props.promotion.code]) && (
                    <>
                        {" "}
                        <div className={"component-main-div-big " + props.promotion.code}>
                            {promoConfig && (
                                    <div className="overlay"></div>
                                )}
                            <div className={"img-container " + props.promotion.code} />
                            {promoConfig && (
                                    <div className="overlay-image"></div>
                                )}
                            <div className="icon-container">
                                {new Date() < new Date(props.promotion.startDate) && (
                                        <div className="starts-in"></div>
                                    )}
                                {new Date() > new Date(props.promotion.startDate) &&
                                    new Date() < new Date(props.promotion.endDate) && (
                                        <div className="active">
                                            <div className="active-dot"></div>
                                        </div>
                                    )}
                                {new Date() > new Date(props.promotion.endDate) && (
                                    <div className="finished">
                                        <p>
                                            <svg
                                                width="15"
                                                height="11"
                                                viewBox="0 0 15 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M14.5588 0.375445C14.8304 0.625925 14.9889 0.971373 14.9994 1.33584C15.01 1.7003 14.8718 2.05394 14.6152 2.319L6.62749 10.57C6.49803 10.7034 6.34246 10.8103 6.16998 10.8841C5.99749 10.9579 5.81158 10.9973 5.62324 10.9999C5.43489 11.0024 5.24793 10.9681 5.0734 10.899C4.89887 10.8299 4.74031 10.7274 4.60708 10.5975L0.378318 6.47198C0.129328 6.2113 -0.00622355 5.86651 0.000219608 5.51025C0.00666277 5.15399 0.154598 4.81407 0.412859 4.56212C0.67112 4.31017 1.01954 4.16585 1.38472 4.15956C1.7499 4.15328 2.10332 4.28552 2.37054 4.52842L5.575 7.65279L12.5666 0.430452C12.8233 0.165499 13.1774 0.010866 13.551 0.00055106C13.9246 -0.00976393 14.2871 0.125084 14.5588 0.375445Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </p>
                                    </div>
                                )}
                                {/*<div className="bonus-type">*/}
                                {/*    <p>SEZONSKI BONUS</p>*/}
                                {/*</div>*/}
                            </div>
                            <div className="content">
                                <p className="title">
                                    {promoConfig.title}
                                </p>

                                <div className="counter-container">
                                    {new Date() >= new Date(props.promotion.startDate) ? (
                                        <h4>
                                            {" "}
                                            Započelo:{" "}
                                            {casino.utils.dateToShortDateString(
                                                new Date(props.promotion.startDate)
                                            )}
                                            . u{" "}
                                            {casino.utils.dateToTimeString(
                                                new Date(props.promotion.startDate)
                                            )}{" "}
                                        </h4>
                                    ) : (
                                        <h4> Promocija započinje za:</h4>
                                    )}
                                    {new Date() <= new Date(props.promotion.startDate) && (
                                        <div className="timer-row">
                                            <div className="days">
                                                {state.days}
                                                <span className="days-text"> dana</span>
                                            </div>
                                            <div className="hours">
                                                {state.hours}
                                                <span className="days-text"> sati</span>
                                            </div>
                                            <div className="minutes">
                                                {state.minutes}
                                                <span className="days-text"> minuta</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <>
                                    <p className="desc-title">
                                        {promoConfig.isTitle && promoConfig.descriptionOne}
                                    </p>
                                    <p className="description">
                                        {!promoConfig.isTitle ?
                                            <>
                                                {promoConfig.descriptionOne && promoConfig.descriptionOne}
                                                <br />
                                                <br />
                                                {promoConfig.descriptionTwo && promoConfig.descriptionTwo}
                                                <br />
                                                <br />
                                                {promoConfig.descriptionThree && promoConfig.descriptionThree}
                                            </>
                                            : <>
                                                {promoConfig.descriptionTwo && promoConfig.descriptionTwo}
                                                <br />
                                                <br />
                                                {promoConfig.descriptionThree && promoConfig.descriptionThree}
                                            </>
                                        }
                                    </p>
                                </>
                                <div className="button-container">
                                    <a
                                        className="promotion-button"
                                        href={props.promotion.buttonActionMobile}
                                    >
                                        <span className={"arrow " + props.promotion.code}>
                                            <svg
                                                width="18"
                                                height="14"
                                                viewBox="0 0 18 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                    fill={
                                                        promoConfig.buttonColor ||
                                                        props.promotion.BackgroundColor ||
                                                        "#B06A19"
                                                    }
                                                />
                                            </svg>
                                            SAZNAJ VIŠE
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            {props.promotion.code == "drops-and-wins" && (
                <>
                    {" "}
                    <div className="component-main-div-big drops-and-wins">
                        <div className="overlay-image"></div>
                        <div className="img-container" />
                        <div className="icon-container">
                            {new Date() < new Date(props.promotion.startDate) && (
                                <div className="starts-in"></div>
                            )}
                            {new Date() > new Date(props.promotion.startDate) &&
                                new Date() < new Date(props.promotion.endDate) && (
                                    <div className="active">
                                        <div className="active-dot"></div>
                                    </div>
                                )}
                            {new Date() > new Date(props.promotion.endDate) && (
                                <div className="finished">
                                    <p>
                                        <svg
                                            width="15"
                                            height="11"
                                            viewBox="0 0 15 11"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M14.5588 0.375445C14.8304 0.625925 14.9889 0.971373 14.9994 1.33584C15.01 1.7003 14.8718 2.05394 14.6152 2.319L6.62749 10.57C6.49803 10.7034 6.34246 10.8103 6.16998 10.8841C5.99749 10.9579 5.81158 10.9973 5.62324 10.9999C5.43489 11.0024 5.24793 10.9681 5.0734 10.899C4.89887 10.8299 4.74031 10.7274 4.60708 10.5975L0.378318 6.47198C0.129328 6.2113 -0.00622355 5.86651 0.000219608 5.51025C0.00666277 5.15399 0.154598 4.81407 0.412859 4.56212C0.67112 4.31017 1.01954 4.16585 1.38472 4.15956C1.7499 4.15328 2.10332 4.28552 2.37054 4.52842L5.575 7.65279L12.5666 0.430452C12.8233 0.165499 13.1774 0.010866 13.551 0.00055106C13.9246 -0.00976393 14.2871 0.125084 14.5588 0.375445Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </p>
                                </div>
                            )}
                        </div>
                        <div className="content">
                            <p className="title">Drops & Wins</p>
                            <div className="prize-container drops">
                                <span className="weekly">Svaki dan</span>
                                {casino.utils.numberWithCurrencyFromated(5000, "EUR")}
                            </div>
                            <>
                                <p className="desc-title">
                                    Pojačavamo zabavu, podižemo uzbuđenja, povećavamo nagrade!
                                </p>
                                <p className="description">
                                    Uključi se u nevjerojatno napeto natjecanje Pragmatic Play
                                    Drops & Wins Slots u kojem imaš priliku osvojiti dnevne
                                    nagrade.
                                </p>
                            </>
                            <div className="button-container">
                                <NavLink
                                    className="promotion-button"
                                    to="promotions/drops-and-wins"
                                >
                                    <span className="arrow drops-and-wins">
                                        <svg
                                            width="18"
                                            height="14"
                                            viewBox="0 0 18 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                fill="#683320"
                                            />
                                        </svg>
                                        SAZNAJ VIŠE
                                    </span>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {props.user &&
                props.challenges &&
                props.promotion.code == "superklub" && (
                    <>
                        {" "}
                        <div className="component-main-div-big superklub">
                            <div className="img-container superklub" />
                            <div className="background-overlay" />
                            <div className="icon-container superklub">
                                <div className="active">
                                    <div className="active-dot"></div>
                                </div>
                            </div>
                            <div className="content superklub">
                                <p className="title" style={{ margin: "19px 0%" }}>
                                    Dnevni Superklub izazovi
                                </p>
                                <div className="scroller">
                                    <div className="challenges-container">
                                        {props.challenges &&
                                            props.challenges.map((challenge, index) => {
                                                return renderChallenge(challenge, index);
                                            })}
                                    </div>
                                </div>

                                <div className="button-container">
                                        <NavLink
                                            className="promotion-button"
                                            to="promotions/superklub"
                                        >
                                            <span className="arrow superklub">
                                                <svg
                                                    width="18"
                                                    height="14"
                                                    viewBox="0 0 18 14"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                        fill="#CF1217 "
                                                    />
                                                </svg>
                                                SVI IZAZOVI
                                            </span>
                                        </NavLink>
                                    </div>
                            </div>
                                
                        </div>
                    </>
                )}

            {(!props.user || (props.user && !props.challenges)) &&
                props.promotion.code == "superklub" && (
                    <>
                        {" "}
                        <div className="component-main-div-big superklub">
                            <div className="img-container superklub" />
                            <div className="background-overlay" />
                            <div className="icon-container superklub">
                                <div className="active">
                                    <div className="active-dot"></div>
                                </div>
                            </div>
                            <div className="content superklub">
                                <p className="title">Superklub izazovi</p>
                                <>
                                    <p className="desc-title" style={{ padding: "0 20px" }}>
                                        SuperKlub ima i svoju posebnu valutu - Supere.
                                    </p>
                                    <p className="description">
                                        Sakupljaj Supere rješavanjem izazova i zamijeni ih za
                                        nagrade ili bonuse koje želiš. Pridruži se zajednici casino
                                        igrača i sportskih znalaca, aktivno igraj i uživaj u
                                        SuperSport ponudi i SuperCasino igricama, a mi ćemo se
                                        pobrinuti za super nagrade. Ti igraš, mi nagrađujemo!
                                    </p>
                                </>
                                <div className="button-container">
                                    <NavLink
                                        className="promotion-button"
                                        to="promotions/superklub"
                                    >
                                        <span className="arrow superklub">
                                            <svg
                                                width="18"
                                                height="14"
                                                viewBox="0 0 18 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                    fill="#CF1217 "
                                                />
                                            </svg>
                                            SVI IZAZOVI
                                        </span>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </>
                )}

            {props.promotion.code == "super-spin" && (
                <>
                    {" "}
                    <div className="component-main-div-big super-spin">
                        <div className="full-black-circle"></div>
                        <div className="img-container" />
                        <div className="icon-container">
                            <div className="active">
                                <div className="active-dot"></div>
                            </div>
                        </div>
                        <div className="content super-spin">
                            <p className="title">SuperSpin</p>
                            <>
                                <p className="desc-title">Svaka vrtnja je dobitna!</p>
                                <p className="description">
                                    Znaš li da je na SuperSpinu svaka vrtnja dobitna? Zato ga
                                    zavrti odmah i osvoji super nagrade!
                                    <br />
                                    Svaki dan imaš pravo na jednu gratis vrtnju ako odigraš barem
                                    2 € na Sport, Virtuali, Loto ili igrama u SuperCasinu
                                </p>
                            </>
                            <div className="button-container">
                                <NavLink className="promotion-button" to="account/superspin">
                                    <span className="arrow super-spin">
                                        <svg
                                            width="18"
                                            height="14"
                                            viewBox="0 0 18 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                fill="#B0011D"
                                            />
                                        </svg>
                                        ZAVRTI
                                    </span>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {props.promotion.code == "casino-izazovi" && (
                <>
                    {" "}
                    <div className="component-main-div-big izazovi">
                        <div className="img-container izazovi" />
                        <div className="icon-container izazovi">
                            <div className="active">
                                <p>AKTIVNO</p>
                            </div>
                            <div className="challenges">
                                <p>TJEDNI IZAZOVI</p>
                            </div>
                        </div>
                        <div className="content izazovi">
                            <p className="title">Casino Izazovi</p>
                            <>
                                <p className="desc-title">
                                    Zaigraj omiljene igre i osvoji posebne nagrade za svoja
                                    postignuća!
                                </p>
                                <p className="description">
                                    Casino izazovi su zabavni zadaci koje možeš izvršiti dok igraš
                                    određene Casino igre. Popis i detalje zadataka možeš pronaći s
                                    lijeve strane, a za svaki zadatak koji ispuniš, osvajaš i
                                    posebnu nagradu. Izazivamo te na zabavu! Igraš? Zaigraj!
                                </p>
                            </>
                            <div className="button-container">
                                <NavLink
                                    className="promotion-button"
                                    to={
                                        "/casino-izazovi" +
                                        (casino.config.fromNativeApp ? "?fromnative=1" : "")
                                    }
                                >
                                    <span className="arrow superklub izazovi">
                                        <svg
                                            width="18"
                                            height="14"
                                            viewBox="0 0 18 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                fill="#443653 "
                                            />
                                        </svg>
                                        SAZNAJ VIŠE
                                    </span>
                                </NavLink>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {(props.promotion.size == 2 || props.promotion.size == 3) && props.promotion.code == "casino-utrke" && (
                <>
                    {imaIgraca ? (
                        <div style={{ marginBottom: "25px" }}>
                            <SuperCasinoUtrkeWidget key={"supercasino-utrke"} promoPage={true} />
                        </div>

                    ) :
                        <div className="component-main-div-big utrke">
                            <div className="icons-container">
                                <div className="active">
                                    <div className="active-dot"></div>
                                </div>
                            </div>
                            <div className="img-container utrke" />
                            <div className="content utrke">
                                <div className="title"></div>
                                <>
                                    <p className="desc-title">
                                        Stisni gas do daske i ubrzaj do pobjede!
                                    </p>
                                    <p className="description">
                                        Ne propusti fenomenalne nagrade, adrenalin i uzbuđenje u SuperCasino utrkama tijekom cijele godine!
                                    </p>
                                </>
                                <div className="button-container">
                                    <NavLink
                                        className="promotion-button"
                                        to={
                                            "/casino-utrke" +
                                            (casino.config.fromNativeApp ? "?fromnative=1" : "")
                                        }
                                    >
                                        <span className="arrow superklub utrke">
                                            <svg
                                                width="18"
                                                height="14"
                                                viewBox="0 0 18 14"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                    fill="#9B0202"
                                                />
                                            </svg>
                                            SAZNAJ VIŠE
                                        </span>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    }
                </>
            )}

            {props.promotion.size == 4 && props.promotion.code == "vip" && (
                <>
                    <div className="vip">
                        <div className="icon-container">
                            <div className="active">
                                <div className="active-dot"></div>
                            </div>
                        </div>
                        <div className="img-container">
                            <div className="kruna" />
                            <div className="casino" />
                            <div className="logo" />
                        </div>
                        <p>
                            Jesi li spreman za najbolje SuperCasino iskustvo samo za odabrane?
                            Ostvari brdo dodatnih nagrada, bonusa i poklona kao VIP član.
                        </p>
                        <div className="button-container">
                            <NavLink className="promotion-button" to="vip">
                                <span className="arrow superklub">
                                    <svg
                                        width="18"
                                        height="14"
                                        viewBox="0 0 18 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                            fill="#CF1217 "
                                        />
                                    </svg>
                                    SVI IZAZOVI
                                </span>
                            </NavLink>
                        </div>
                    </div>
                </>
            )}

            {props.promotion.size == 4 && props.promotion.code == "first-depozit" && (
                <div className="first-deposit-component">
                    <span className="ilustracija-img"></span>
                    <div className="icons-container">
                        <div className="active">
                            <div className="active-dot"></div>
                        </div>
                    </div>
                    <h2 className="depozit-title">Bonus dobrodošlice</h2>
                    <div className="deposit-content-container">
                        <div className="row">
                            <div className="spins">
                                <p className="amount">500</p>
                                <p className="bonus-text">BESPLATNIH VRTNJI</p>
                                {/*<p className="registration">za registraciju</p>*/}
                            </div>
                            <hr className="depozit-hr" />
                            <div className="spins">
                                <p className="amount">do 300 €</p>
                                <p className="bonus-text">BONUSA</p>
                                <p className="registration">na prvu uplatu</p>
                            </div>
                        </div>
                        <div className="buttons-container">
                            <NavLink
                                to="promotions/first-deposit"
                                href="https://mcasino.supersport.hr/promotions/first-deposit"
                            >
                                <button className="promotion-button-left">
                                    <span>
                                        <svg
                                            width="18"
                                            height="14"
                                            viewBox="0 0 18 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                fill="#CF1217 "
                                            />
                                        </svg>
                                    </span>
                                    SAZNAJ VIŠE
                                </button>
                            </NavLink>
                        </div>
                    </div>
                </div>
            )}

            {props.promotion.size == 4 &&
                props.promotion.code == "super-kisa" &&
                props.superKisaForecast && (
                <div className={"component-main-div-big " + props.promotion.code}>
                        <div className="icons-container">
                            <div className="active">
                                <div className="active-dot"></div>
                            </div>
                        </div>
                        <div className="img-superlik">
                            {/*<div className="live">*/}
                            {/*    <span className="dot">*/}
                            {/*        <span className="pulse-1"></span>*/}
                            {/*        <span className="pulse-2"></span>*/}
                            {/*    </span>*/}
                            {/*    <span>AKTIVNO</span>*/}
                            {/*</div>*/}
                        </div>
                        <div className="content">
                        <h4>SuperKiša SP26</h4>
                            {/* <div className="egt-digital"></div>*/}
                            <div className="info-text">
                                <span className="info-icon"></span>
                                {props.superKisaForecast.find(
                                    (x) =>
                                        x.weatherIcon == "superkisa-kisa.riv" ||
                                        x.weatherIcon == "superkisa-poklon.riv"
                                ) != null && (
                                        <span className="text-content">
                                            Danas predviđamo SuperKišu u određenim periodima! Pokisni od
                                            nagrada!
                                        </span>
                                    )}
                                {props.superKisaForecast.find(
                                    (x) =>
                                        x.weatherIcon == "superkisa-kisa.riv" ||
                                        x.weatherIcon == "superkisa-poklon.riv"
                                ) == null && (
                                        <span className="text-content">
                                            Svakodnevno prati našu prognozu i saznaj kada predviđamo
                                            SuperKišu nagrada!
                                        </span>
                                    )}
                            </div>
                            <div className="forecast">
                                {props.superKisaForecast.map((item, index) => {
                                    return (
                                        <div key={index} className={"forecast-item"}>
                                            {time >= item.start && time < item.end && (
                                                <div className="current">
                                                    <span className="dot">
                                                        <span className="pulse-1"></span>
                                                        <span className="pulse-2"></span>
                                                    </span>
                                                    <span>Trenutno</span>
                                                </div>
                                            )}
                                            <div className="forecast-time">
                                                {item.start < 10 ? "0" : ""}
                                                {item.start}:00 - {item.end < 10 ? "0" : ""}
                                                {item.end}:00
                                            </div>
                                            <div className="forecast-weather">
                                                <RiveComponent
                                                    className="weather-icon"
                                                    lazyLoad={true}
                                                    cacheBust={`c=${casino.config.guiCacheVerzija}`}
                                                    src={`Content/Images/Bonusi/SuperKisa/${item.weatherIcon}`}
                                                    useOffscreenRenderer={true}
                                                    playRequest={true}
                                                    disablePlayOutsideViewport={true}
                                                />
                                                <div className="weather-text">{item.weather}</div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <NavLink
                                className="btn-promotion-link"
                                to="/promotions/superkisa"
                            >
                                <svg
                                    width="18"
                                    height="14"
                                    viewBox="0 0 18 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.4228 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                        fill="#2A82C4"
                                    />
                                </svg>
                                Saznaj više
                            </NavLink>
                        </div>
                    </div>
                )}

            {props.promotion.size == 3 && props.promotion.code != "casino-utrke" && props.promotion.code != "drops-and-wins" && props.promotion.code != "super-spin" && !PROMOTIONS_BY_CODE[props.promotion.code] && (
                    <>
                        <div
                            className={
                                "component-main-div-big " +
                                props.promotion.backgroundColor +
                                " " +
                                props.promotion.code
                            }
                        >
                            {(props.promotion.code == "SuperBombaEGTDigitalEarlyDecember2025" || props.promotion.code == "SuperBombaEGTDigitalLateDecember2025" || props.promotion.code == "SuperBombaPragmaticDecember2025" || props.promotion.code == "SuperBombaFaziDecember2025") && (
                                    <div className="overlay-image"></div>
                                )}
                            <div
                                className="img-container"
                                style={{
                                    backgroundImage:
                                        "url(" +
                                        casino.config.casinoImagesPromotionsUrl +
                                        props.promotion.image +
                                        ")",
                                }}
                            />
                            <div className="icon-container">
                                {new Date() < new Date(props.promotion.startDate) && (
                                        <div className="starts-in"></div>
                                    )}
                                {new Date() > new Date(props.promotion.startDate) &&
                                    new Date() < new Date(props.promotion.endDate) && (
                                        <div className="active">
                                            <div className="active-dot"></div>
                                        </div>
                                    )}
                                {new Date() > new Date(props.promotion.endDate) && (
                                    <div className="finished">
                                        <p>
                                            <svg
                                                width="15"
                                                height="11"
                                                viewBox="0 0 15 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M14.5588 0.375445C14.8304 0.625925 14.9889 0.971373 14.9994 1.33584C15.01 1.7003 14.8718 2.05394 14.6152 2.319L6.62749 10.57C6.49803 10.7034 6.34246 10.8103 6.16998 10.8841C5.99749 10.9579 5.81158 10.9973 5.62324 10.9999C5.43489 11.0024 5.24793 10.9681 5.0734 10.899C4.89887 10.8299 4.74031 10.7274 4.60708 10.5975L0.378318 6.47198C0.129328 6.2113 -0.00622355 5.86651 0.000219608 5.51025C0.00666277 5.15399 0.154598 4.81407 0.412859 4.56212C0.67112 4.31017 1.01954 4.16585 1.38472 4.15956C1.7499 4.15328 2.10332 4.28552 2.37054 4.52842L5.575 7.65279L12.5666 0.430452C12.8233 0.165499 13.1774 0.010866 13.551 0.00055106C13.9246 -0.00976393 14.2871 0.125084 14.5588 0.375445Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </p>
                                    </div>
                                )}
                                {/*<div className="bonus-type">*/}
                                {/*    <p>*/}
                                {/*        {props.promotion.dailyBonus ? "DNEVNI " : "POVREMENI "}BONUS*/}
                                {/*    </p>*/}
                                {/*</div>*/}
                            </div>
                            <div className="content">
                                <p className="title">{props.promotion.titleSmall}</p>
                                <div className="counter-container">
                                    {new Date() >= new Date(props.promotion.startDate) ? (
                                        <>
                                            <h4>
                                                {" "}
                                                Započelo:{" "}
                                                {casino.utils.dateToShortDateString(
                                                    new Date(props.promotion.startDate)
                                                )}
                                                . u{" "}
                                                {casino.utils.dateToTimeString(
                                                    new Date(props.promotion.startDate)
                                                )}{" "}
                                            </h4>
                                            {new Date() >= new Date(props.promotion.endDate) && (
                                                    <h4>
                                                        {" "}
                                                        Započelo:{" "}
                                                        {casino.utils.dateToShortDateString(
                                                            new Date(props.promotion.endDate)
                                                        )}
                                                        . u{" "}
                                                        {casino.utils.dateToTimeString(
                                                            new Date(props.promotion.endDate)
                                                        )}{" "}
                                                    </h4>
                                                )}
                                        </>
                                    ) : (
                                        <h4> Promocija započinje za:</h4>
                                    )}
                                    {new Date() <= new Date(props.promotion.startDate) && (
                                        <div className="timer-row">
                                            <div className="days">
                                                {state.days}
                                                <span className="days-text"> dana</span>
                                            </div>
                                            <div className="hours">
                                                {state.hours}
                                                <span className="days-text"> sati</span>
                                            </div>
                                            <div className="hours">
                                                {state.minutes}
                                                <span className="days-text"> minuta</span>
                                            </div>
                                            <div className="minutes">
                                                {state.seconds}
                                                <span className="days-text"> sekunde</span>{" "}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="prize-container">
                                    {casino.utils.numberWithCurrencyFromated(
                                        props.promotion.code ==
                                            "SuperCasinoSuperskokSuperTravanj2024"
                                            ? 220000
                                            : props.promotion.totalPrize,
                                        props.promotion.valuta
                                    )}
                                </div>
                                {(props.promotion &&
                                    props.promotion.winners &&
                                    props.promotion.winners.length < 1) ||
                                    props.promotion.vrstaKampanje == "CasinoSprintBrojSpinova" ||
                                    props.promotion.vrstaKampanje == "CasinoSprintTurnover" ||
                                    (!props.promotion.finished && !props.promotion.started) ? (
                                    <>
                                        <p className="desc-title">Kako igrati</p>
                                        <p className="description">{props.promotion.description}</p>
                                    </>
                                ) : (
                                    <div className="results-container">{renderResults()}</div>
                                )}
                                <div className="button-container">
                                    {props.promotion.buttonActionMobile && (
                                        <a
                                            className={
                                                "promotion-button " + props.promotion.backgroundColor
                                            }
                                            target="_self"
                                            href={props.promotion.buttonActionMobile}
                                        >
                                            <svg
                                                className={"fill " + props.promotion.backgroundColor}
                                                width="18"
                                                height="14"
                                                viewBox="0 0 18 14"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                    fill=""
                                                />
                                            </svg>
                                            {props.promotion.buttonText}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}

            {props.promotion.size == 2 && props.promotion.code != "casino-utrke" && props.promotion.code != "drops-and-wins" && props.promotion.code != "superklub" && props.promotion.code != "super-spin" && !PROMOTIONS_BY_CODE[props.promotion.code] && (
                    <>
                        <div
                            className={
                                "component-main-div-medium " + props.promotion.backgroundColor + " " + props.promotion.code
                            }
                        >
                            {(props.promotion.code == "SuperBombaEGTDigitalEarlyDecember2025" || props.promotion.code == "SuperBombaEGTDigitalLateDecember2025" || props.promotion.code == "SuperBombaPragmaticDecember2025"|| props.promotion.code == "SuperBombaFaziDecember2025") && (
                                    <div className="overlay-image"></div>
                            )}
                            <div className="top-container">
                                <div className="icon-container">
                                    {new Date() < new Date(props.promotion.startDate) && (
                                            <div className="starts-in"></div>
                                        )}
                                    {new Date() > new Date(props.promotion.startDate) &&
                                        new Date() < new Date(props.promotion.endDate) && (
                                            <div className="active">
                                                <div className="active-dot"></div>
                                            </div>
                                        )}
                                    {new Date() > new Date(props.promotion.endDate) && (
                                        <div className="finished">
                                            <p>
                                                <svg
                                                    width="15"
                                                    height="11"
                                                    viewBox="0 0 15 11"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M14.5588 0.375445C14.8304 0.625925 14.9889 0.971373 14.9994 1.33584C15.01 1.7003 14.8718 2.05394 14.6152 2.319L6.62749 10.57C6.49803 10.7034 6.34246 10.8103 6.16998 10.8841C5.99749 10.9579 5.81158 10.9973 5.62324 10.9999C5.43489 11.0024 5.24793 10.9681 5.0734 10.899C4.89887 10.8299 4.74031 10.7274 4.60708 10.5975L0.378318 6.47198C0.129328 6.2113 -0.00622355 5.86651 0.000219608 5.51025C0.00666277 5.15399 0.154598 4.81407 0.412859 4.56212C0.67112 4.31017 1.01954 4.16585 1.38472 4.15956C1.7499 4.15328 2.10332 4.28552 2.37054 4.52842L5.575 7.65279L12.5666 0.430452C12.8233 0.165499 13.1774 0.010866 13.551 0.00055106C13.9246 -0.00976393 14.2871 0.125084 14.5588 0.375445Z"
                                                        fill="white"
                                                    />
                                                </svg>
                                            </p>
                                        </div>
                                    )}
                                    {/*<div className="bonus-type">*/}
                                    {/*    <p>*/}
                                    {/*        {props.promotion.dailyBonus ? "DNEVNI " : "POVREMENI "}*/}
                                    {/*        BONUS*/}
                                    {/*    </p>*/}
                                    {/*</div>*/}
                                </div>
                                <div
                                    className="img-container"
                                    style={{
                                        backgroundImage:
                                            "url(" +
                                            casino.config.casinoImagesPromotionsUrl +
                                            (props.promotion.image
                                                ? props.promotion.image.substring(
                                                    0,
                                                    props.promotion.image.lastIndexOf(".")
                                                ) +
                                                "Medium" +
                                                props.promotion.image.substring(
                                                    props.promotion.image.lastIndexOf(".")
                                                )
                                                : "") +
                                            ")",
                                    }}
                                />
                            </div>
                            <div className="content">
                                <p className="title">{props.promotion.titleSmall}</p>
                                <div className="counter-container">
                                    {new Date() >= new Date(props.promotion.startDate) ? (
                                        <>
                                            <h4>
                                                {" "}
                                                Započelo:{" "}
                                                {casino.utils.dateToShortDateString(
                                                    new Date(props.promotion.startDate)
                                                )}
                                                . u{" "}
                                                {casino.utils.dateToTimeString(
                                                    new Date(props.promotion.startDate)
                                                )}{" "}
                                            </h4>
                                            {new Date() >= new Date(props.promotion.endDate) && (
                                                    <h4>
                                                        {" "}
                                                        Započelo:{" "}
                                                        {casino.utils.dateToShortDateString(
                                                            new Date(props.promotion.endDate)
                                                        )}
                                                        . u{" "}
                                                        {casino.utils.dateToTimeString(
                                                            new Date(props.promotion.endDate)
                                                        )}{" "}
                                                    </h4>
                                                )}
                                        </>
                                    ) : (
                                        <h4> Promocija započinje za:</h4>
                                    )}
                                    {new Date() <= new Date(props.promotion.startDate) && (
                                        <div className="timer-row">
                                            <div className="days">
                                                {state.days}
                                                <span className="days-text"> dana</span>
                                            </div>
                                            <div className="hours">
                                                {state.hours}
                                                <span className="days-text"> sati</span>
                                            </div>
                                            <div className="hours">
                                                {state.minutes}
                                                <span className="days-text"> minuta</span>
                                            </div>
                                            <div className="minutes">
                                                {state.seconds}
                                                <span className="days-text"> sekunde</span>{" "}
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="prize-container">
                                    {casino.utils.numberWithCurrencyFromated(
                                        props.promotion.totalPrize,
                                        props.promotion.valuta
                                    )}
                                </div>

                                <div className="button-container">
                                    {props.promotion.buttonActionMobile && (
                                        <a
                                            className={
                                                "promotion-button " + props.promotion.backgroundColor
                                            }
                                            target="_self"
                                            href={props.promotion.buttonActionMobile}
                                        >
                                            <svg
                                                className={"fill " + props.promotion.backgroundColor}
                                                width="18"
                                                height="14"
                                                viewBox="0 0 18 14"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                    fill=""
                                                />
                                            </svg>
                                            {props.promotion.buttonText}
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}

            {props.promotion.size == 1 &&
                props.promotion.code != "drops-and-wins" &&
                props.promotion.code != "super-spin" && (
                    <>
                        <div
                            className={
                                "component-main-div-small " + props.promotion.backgroundColor
                            }
                        >
                            <div className="component-img"></div>
                            <div
                                className={"img-container " + props.promotion.code}
                                style={{
                                    backgroundImage:
                                        "url(" +
                                        casino.config.casinoImagesPromotionsUrl +
                                        (props.promotion.image
                                            ? props.promotion.image.substring(
                                                0,
                                                props.promotion.image.lastIndexOf(".")
                                            ) +
                                            "Small" +
                                            props.promotion.image.substring(
                                                props.promotion.image.lastIndexOf(".")
                                            )
                                            : "") +
                                        ")",
                                }}
                            ></div>
                            <div className="title">
                                <h1>{props.promotion.titleSmall}</h1>
                            </div>
                            <div className="buttons-container">
                                {props.promotion.buttonActionMobile && (
                                    <a
                                        className={
                                            "promotion-button small " +
                                            props.promotion.backgroundColor
                                        }
                                        target="_self"
                                        href={props.promotion.buttonActionMobile}
                                    >
                                        <svg
                                            className={"fill " + props.promotion.backgroundColor}
                                            style={{ position: "relative" }}
                                            width="18"
                                            height="14"
                                            viewBox="0 0 18 14"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.44221 13.6233C9.18539 13.3722 9.06212 13.0688 9.07239 12.713C9.08352 12.3572 9.2175 12.0538 9.47432 11.8027L13.1019 8.2556H1.78411C1.42028 8.2556 1.11509 8.13507 0.86854 7.89399C0.622847 7.65375 0.5 7.35575 0.5 7C0.5 6.64424 0.622847 6.34583 0.86854 6.10475C1.11509 5.86451 1.42028 5.74439 1.78411 5.74439H13.1019L9.44221 2.16592C9.18539 1.9148 9.05698 1.61638 9.05698 1.27067C9.05698 0.925799 9.18539 0.627802 9.44221 0.376681C9.69904 0.12556 10.0042 0 10.3578 0C10.7105 0 11.0152 0.12556 11.2721 0.376681L17.1469 6.12108C17.2753 6.24664 17.3665 6.38266 17.4204 6.52915C17.4735 6.67563 17.5 6.83259 17.5 7C17.5 7.16741 17.4735 7.32436 17.4204 7.47085C17.3665 7.61734 17.2753 7.75336 17.1469 7.87892L11.24 13.6547C11.0045 13.8849 10.7105 14 10.3578 14C10.0042 14 9.69904 13.8744 9.44221 13.6233Z"
                                                fill=""
                                            />
                                        </svg>
                                    </a>
                                )}
                                {/*<button className={"promotion-button-left " + props.promotion.backgroundColor} onClick={() => navigateToBonus(props.promotion.buttonActionMobile)}><span className="arrow">➜</span></button>*/}
                            </div>
                        </div>
                    </>
                )}
        </>
    );
}
